import { Box } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../Components/Common/CustomButton/CustomButton";
import QuoteNavbar from "../../../Components/Desktop/QuoteNavbar/QuoteNavbar";
import { PATH } from "../../../shared/Path";
import "./ThankYouPage.scss";

function ThankYouPage() {
  const navigate = useNavigate();

  return (
    <Box className="thankYouWrapper">
      <QuoteNavbar />
      <Box className="thankYouContent">
        <div className="successIcon">
          <svg
            width="80"
            height="80"
            viewBox="0 0 120 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="60" cy="60" r="60" fill="#6458D8" fillOpacity="0.1" />
            <circle cx="60" cy="60" r="45" fill="#6458D8" />
            <path
              d="M45 60L55 70L75 50"
              stroke="white"
              strokeWidth="6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        <h1>Thank You!</h1>
        <h4>Your Payment was Successful</h4>
        <p className="message">
          Your travel insurance policy has been successfully purchased. You will
          receive a confirmation email shortly with your policy details.
        </p>
        <Box className="policyDetails">
          <div className="detailItem">
            <span className="label">Policy Number:</span>
            <span className="value">
              #TI{Math.floor(Math.random() * 1000000)}
            </span>
          </div>
          <div className="detailItem">
            <span className="label">Payment Status:</span>
            <span className="value status">Confirmed</span>
          </div>
        </Box>
        <p className="note">
          A copy of your policy document will be sent to your registered email
          address within 24 hours.
        </p>
        <Box className="actionButtons ctaBtn">
          <CustomButton
            text_name="Back to Home"
            class_name="backBtn"
            onClickFunction={() => {
              navigate(PATH.HOME);
            }}
          />
          <CustomButton
            text_name="Download Policy"
            class_name="blueLgBtn"
            onClickFunction={() => {
              // Add download functionality here
              alert("Policy download feature will be implemented");
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default ThankYouPage;
